import { render, staticRenderFns } from "./installClone.vue?vue&type=template&id=1002f37b&scoped=true&"
import script from "./installClone.vue?vue&type=script&lang=js&"
export * from "./installClone.vue?vue&type=script&lang=js&"
import style0 from "./installClone.vue?vue&type=style&index=0&id=1002f37b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1002f37b",
  null
  
)

export default component.exports